import { JetView } from 'webix-jet'; // Base class for Webix Jet views
import { devConfig } from 'config/config'; // Application configuration and permissions

export default class configNtcView extends JetView {

    ready() {
        // Helper function to safely set the input value
        const setValue = (value) => {
            if (value !== undefined && value !== null) { // Only set valid values
                const input = $$('TimeMinutesNTC'); // Get input by id
                if (input) {
                    input.setValue(value); // Update input value
                }
            }
        };

        setValue(this.app.config.TimeMinutesNTC); // Initialize input from global cache

        this.on(this.app, "ntc:update", (value) => { // Listen for global NTC updates
            setValue(value); // Update input when event is triggered
        });
    }

    config() {
        const _ = this.app.getService('locale')._; // Localization service

        const hasPermission = devConfig.getPermAction(
            'betShopManagementConfigurationEditConfigNtc',
            'Menu'
        ); // Check edit permissions

        // Input configuration
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    type: 'number',                 // ⬅️ input numérico real
                    step: 1,                        // ⬅️ SOLO enteros
                    name: 'TimeMinutesNTC',
                    id: 'TimeMinutesNTC',
                    label: _('Tiempo de exclusión NTC (minutos)'),
                    labelPosition: 'top',
                    placeholder: _('Ingrese el tiempo en minutos'),
                    readonly: !hasPermission,
                    validate: (value) => {
                        if (value === '' || value === null) return true;

                        const n = Number(value);
                        return Number.isInteger(n) && n > 0;
                    },
                    invalidMessage: _('Debe ingresar un número entero mayor a 0'),
                    on: {
                        onBlur() {
                            this.validate();
                        }
                    }
                }
            ]
        };


        const upper_section = {
            rows: [
                {
                    margin: 10,
                    cols: [center_left], // Layout container
                },
            ],
        };

        // Action buttons section
        const buttons = {
            margin: 10,
            cols: [
                {}, // Spacer
                ...(hasPermission
                    ? [{
                        view: 'button', // Save button
                        value: _('Guardar'), // Button text
                        type: 'form', // Form button type
                        autowidth: true, // Auto width
                        click: () => this.saveTimeNTC(), // Save action
                    }]
                    : []),
            ],
        };

        return {
            view: 'form', // Root form
            id: 'formConfigNtc', // Form id
            rows: [upper_section, buttons], // Form layout
        };
    }

    saveTimeNTC() {
        const _ = this.app.getService('locale')._; // Localization service

        if (!this.getRoot().validate()) { // Validate form before submit
            webix.message({
                title: _('¡Error!'),
                type: 'alert-error',
                text: _('Completa los campos correctamente'),
            });
            return;
        }

        const values = this.getRoot().getValues(); // Get form values
        const id = this.getParam('user', true); // Get user id from route

        const payload = { id }; // Base payload

        if (values.TimeMinutesNTC !== '') {
            payload.TimeMinutesNTC = values.TimeMinutesNTC; // Add value only if not empty
        }

        webix.confirm({
            type: 'confirm-warning', // Confirmation dialog
            text: _('¿Desea guardar el tiempo de exclusión NTC?'),
            ok: _('Guardar'),
            cancel: _('Cancelar'),
            callback: (action) => {
                if (!action) return; // Abort if cancelled

                webix.ajax()
                    .headers({ 'Content-type': 'application/json' }) // Set request headers
                    .post(devConfig.geturlApi() + 'BetShop/UpdateTimeNtc', payload) // API request
                    .then((res) => {
                        const json = res.json(); // Parse response

                        if (json.HasError) { // Handle backend error
                            webix.message({
                                title: _('¡Error!'),
                                type: 'alert-error',
                                text: json.AlertMessage,
                            });
                            return;
                        }

                        const newValue = values.TimeMinutesNTC || null; // Normalize value

                        this.app.config.TimeMinutesNTC = newValue; // Update global cache

                        this.app.callEvent("ntc:update", [newValue]); // Notify all active views

                        webix.message({
                            title: _('¡Éxito!'),
                            type: 'alert-success',
                            text: _('Tiempo de exclusión guardado correctamente'),
                        });
                    })
                    .catch(() => {
                        webix.message({
                            title: _('Error'),
                            type: 'alert-error',
                            text: _('Error de comunicación con el servidor'),
                        });
                    });
            },
        });
    }
}
